<template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="reset"
      @keydown="form.onKeydown($event)"
    >
        <toolbar
          :title="title"
          :loading="form.busy"
          enctype="multipart/form-data"
          :buttons="buttons"
          @save="save"
          @cancel="cancel"
        />
        <v-layout
          :id="ref"
          class="wrap justify-space-around form-body"
        >
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.description"
              :rules="[rules.required]"
              maxlength="100"
              label="Descripción"
              placeholder="Mi Plantilla Generica"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="form.version"
              :rules="[rules.required]"
              maxlength="10"
              label="Versión"
              placeholder="1.0"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="form.doc_type"
              :items="documentTypes"
              label="Tipo de Documento"
              :rules="[rules.required]"
              required
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="form.id_template"
              :rules="[rules.required]"
              :items="templatesList"
              :filter="customFilter"
              item-value="id"
              item-text="name"
              label="Plantillas"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} - {{ data.item.version }}
              </template>
              <template v-slot:item="data">
                {{ data.item.name }} - {{ data.item.version }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-list>
              <v-file-input
                v-model="form.PiePagImagen"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Imagen Pie Pag"
                prepend-icon="mdi-camera"
                label="Imagen Pie Página"
                show-size
                :rules="[rules.size]"
              ></v-file-input>
            </v-list>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-list>
              <v-file-input
                v-model="form.EncabezadoImagen"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Encabezado Imagen"
                prepend-icon="mdi-camera"
                label="Encabezado Imagen"
                show-size
                :rules="[rules.size]"
              ></v-file-input>
            </v-list>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-list>
              <v-file-input
                v-model="form.MarcaAguaPersonalizada"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Marca Agua"
                prepend-icon="mdi-camera"
                label="Marca Agua Personalizada"
                show-size
                :rules="[rules.size]"
              ></v-file-input>
            </v-list>
          </v-col>
        </v-layout>
    </v-form>
  </template>

  <script>
  import Form from 'vform';
  import Toolbar from '~/components/Toolbar';

  export default {
    middleware: 'auth',
    components: {
      Toolbar,
    },
    props: {
      enterpriseId: { default: '' },
      action: { default: '' },
      message: { default: '' },
    },
    data: () => ({
        form: new Form({
          id_template: '',
          version: '1.0',
          active: '1',
          doc_type: '00',
          template: 'XSL',
          description: '',
          PiePagImagen: [],
          EncabezadoImagen: [],
          MarcaAguaPersonalizada: [],
          busy: false,
        }),
        items: [
          { value: '00', text: 'Todos los Documentos' },
        ],
        templatesList: [],
        name: '',
        default: '',
        title: 'Asociación de Representación PDF (Generica)',
        dialog: false,
        valid: false,
        rules: {
          required: (v) => !!v || 'El campo es requerido.',
          size: (v) => (!!v || v.size < 1000000) || 'Su logo no debe exceder de 1MB de tamaño.',
        },
        buttons: [
          {
            id: 'save',
            icon: 'mdi-content-save',
            name: 'Guardar',
            event: 'save',
            color: 'success',
          },
          {
            id: 'cancel',
            icon: 'mdi-close',
            name: 'Volver',
            event: 'cancel',
          },
        ],
        documentTypes: [
          { value: '00', text: 'Todos' },
          { value: '01', text: 'Factura' },
          { value: '02', text: 'Nota de Crédito' },
          { value: '03', text: 'Nota de Débito' },
          { value: '04', text: 'Guías de Despacho' },
          { value: '05', text: 'Comprobante de Retención de IVA' },
          { value: '06', text: 'Comprobante de Retención de ISLR' },
        ],
        apiURL: '/api/enterprises',
        apiURLTemplate: 'templates/store',
        method: 'POST',
    }),
    mounted() {
      window.axios.get('/api/catalogs/templates/getAllTemplates')
        .then((result) => {
          this.showAdd = !this.showAdd;
          this.templatesList = result.data.items;
          this.default = this.templatesList.filter((template) => template.name === 'Generica2');
          this.form.id_template = this.default[0].id;
      });
    },
    computed: {
      ref() { return this.form.id; },
      enterprise() {
        return this.$store.state.profile.enterprise;
      },
    },
    methods: {
        customFilter(item, queryText) {
          const textOne = (item.name !== null) ? item.name.toLowerCase() : '';
          const textTwo = (item.version !== null) ? item.version.toLowerCase() : '';
          const searchText = queryText.toLowerCase();

          return textOne.indexOf(searchText) > -1
            || textTwo.indexOf(searchText) > -1;
        },
        validate() {
          if (this.$refs.form.validate()) {
            this.form.busy = true;
            this.store();
          }
        },
        store() {
          const formData = new FormData();
          formData.append('PiePagImagen', this.form.PiePagImagen);
          formData.append('EncabezadoImagen', this.form.EncabezadoImagen);
          formData.append('MarcaAguaPersonalizada', this.form.MarcaAguaPersonalizada);
          formData.append('id_template', this.form.id_template);
          formData.append('template', this.form.template);
          formData.append('doc_type', this.form.doc_type);
          formData.append('description', this.form.description);
          formData.append('version', this.form.version);
          const config = {
              headers: {
                  'content-type': 'multipart/form-data',
              },
          };
          window.axios.post(`${this.apiURL}/${this.enterpriseId}/${this.apiURLTemplate}`, formData, config)
          .then(() => {
            this.form.busy = false;
            this.$router.go(-1);
          }).catch(() => {
            this.form.busy = false;
          });
        },
        save() {
          this.validate(); // someValue
        },
        cancel() {
          this.$router.go(-1); // someValue
        },
      },
  };
  </script>
